import Swiper from "swiper/bundle";

const CoinsSlider = () => {
  const sliders = Array.from(document.querySelectorAll(".coins__slider"));
  if (sliders.length > 0) {
    sliders.forEach((slider) => {
      const initSlider = new Swiper(slider, {
        loop: true,
        slidesPerView: 1.1,
        centeredSlides: true,
        lazy: {
          loadPrevNext: true,
        },
        pagination: {
          el: slider.querySelector(".slider__pagination"),
          clickable: true,
          dynamicBullets: true,
        },
        navigation: {
          nextEl: slider.querySelector(".slider__next-btn"),
          prevEl: slider.querySelector(".slider__prev-btn"),
        },

        breakpoints: {
          520: {
            slidesPerView: 1.3,
          },
        },
      });
    });
  }
};

export default CoinsSlider;
